import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { USER_FORM_FIELD_NAME_CONTRACT_END } from '../../../../User'

function ContractEndField() {
  const { t } = useTranslation()
  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.ContractEndLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={USER_FORM_FIELD_NAME_CONTRACT_END}
      placeholder={t('Inhabitant.ContractEndPlaceholderKey')}
    />
  )
}

export default ContractEndField
